import { FC } from 'react';
import { IRecording } from '../../appointments/recording/RecordingState';
import { Text } from '../../components/Text';
import { CircleCheckIcon } from '../../theme/Icons';
import { useBreakpoints } from '../../theme/useBreakpoints';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { RecordingState } from '../../appointments/recording/RecordingState';

export type INotesListActionItemCountProps = {
    recording: IRecording;
};

export const NotesListActionItemCount: FC<INotesListActionItemCountProps> = ({ recording }) => {
    const { isAboveCustomBreakpoint } = useBreakpoints();
    const recordingState = useInstance(RecordingState);

    if (!recording) return null;

    const stats = recordingState.getActionItemCompletionStats(recording);

    if (stats.total === 0) return null;

    const isAllCompleted = stats.completed === stats.total;
    const showProgress = stats.completed > 0 && !isAllCompleted;

    // Helper function to get proper singular/plural text
    const getActionText = (count: number) => {
        if (isAboveCustomBreakpoint(410)) {
            return count === 1 ? 'action item' : 'action items';
        } else {
            // Use "done" instead of "actions" when any items are completed to save space
            return stats.completed > 0 ? 'done' : (count === 1 ? 'action' : 'actions');
        }
    };

    const getCompletedText = (count: number) => {
        if (isAboveCustomBreakpoint(410)) {
            return count === 1 ? 'action completed' : 'actions completed';
        } else {
            return 'done';
        }
    };

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
            <CircleCheckIcon color={isAllCompleted ? 'success' : 'medium'} />
            <Text color={isAllCompleted ? 'success' : 'medium'}>
                <div style={{fontSize: 14}}>
                    {showProgress ? (
                        `${stats.completed}/${stats.total} ${getActionText(stats.total)}`
                    ) : isAllCompleted ? (
                        `${stats.total} ${getCompletedText(stats.total)}`
                    ) : (
                        `${stats.total} ${getActionText(stats.total)}`
                    )}
                </div>
            </Text>
        </div>
    );
};
